import { render } from "./SystemLegalConsents.vue?vue&type=template&id=1ed484d8&scoped=true"
import script from "./SystemLegalConsents.vue?vue&type=script&lang=js"
export * from "./SystemLegalConsents.vue?vue&type=script&lang=js"

import "./SystemLegalConsents.vue?vue&type=style&index=0&id=1ed484d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed484d8"]])

export default __exports__